import { MDBBtn, MDBIcon, MDBModalFooter, MDBRadio } from "mdb-react-ui-kit";
import React from "react";
import {
  portingSteps,
  portingStepsForm,
} from "../../../apiclients/streamsapi_bridge";

export default function TNCheckList({
  nextPageclick,
  handleBack,
  currentStep,
  register,
  watch,
  setValue,
  clearErrors,
  handleSubmit,
  formState,
  setError,
  portingType,
  setflowStep,
  flowStep,
  setbackFlag,
  setsavedDraftData,
  isChanged,
  setSuccessMessage,
  setorderID,
  orderID,
}) {
  const { dirtyFields, isDirty, errors } = formState;

  // Prevent MDB Modal's window-level focus trap from intercepting Tab.
  // stopPropagation stops bubbling to window listeners but does NOT prevent
  // the browser's default Tab focus movement.
  const handleTabKeyNavigation = (e) => {
    if (e.key !== "Tab") return;
    e.stopPropagation();
  };

  const handleNext = async (data) => {
    const keys = dirtyFields.checklist;
    const keysData = data.checklist;
    let modifiedData = {};
    for (const field of Object.keys(keysData)) {
      modifiedData[field] = keysData[field];
    }

    console.log("modifiedData :::::::::: " + JSON.stringify(modifiedData));
    let update = {
      reqid: parseInt(portingType) === 2 ? 95 : 91,
      siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      checklist: modifiedData,
      port_type: parseInt(portingType),
      flow_step: parseInt(flowStep),
      // checklist: modifiedData,
    };

    console.log("update :::::::::: " + JSON.stringify(update));

    let saverep = await portingSteps(update);
    console.log(`reponse of next :::: ${JSON.stringify(saverep)}`);
    let saverepeMsg = await saverep.json();
    console.log("response of next:::" + JSON.stringify(saverepeMsg));
    if (saverepeMsg.status && saverepeMsg.status == "success") {
      setflowStep(parseInt(flowStep) + 1);
      nextPageclick();
    } else {
      if (saverepeMsg.message?.errors) {
        saverepeMsg.message.errors.forEach((err) => {
          setError(err.param_name, {
            type: "server",
            message: err.message,
          });
          const fieldElement = document.querySelector(
            `input[name="${err.param_name}"]`
          );
          if (fieldElement) {
            fieldElement.focus();
            fieldElement.scrollIntoView({ behavior: "smooth" });
          }
        });
      } else {
        //   setInternalError(true);
      }
    }
  };

  const handleForBack = () => {
    setbackFlag(true);
    handleBack();
  };

  const handleSaveDraft = async (data) => {
    if (Object.keys(dirtyFields).length > 0) {
      // const modifiedData = {};
      // for (const field of Object.keys(dirtyFields)) {
      //   if (dirtyFields[field] && data.hasOwnProperty(field)) {
      //     if (typeof data[field] === "object" && !Array.isArray(data[field])) {
      //       modifiedData[field] = {};
      //       for (const subfield of Object.keys(dirtyFields[field])) {
      //         if (data[field].hasOwnProperty(subfield)) {
      //           modifiedData[field][subfield] = data[field][subfield];
      //         }
      //       }
      //       if (field === "acc_info" && portingType === 2) {
      //         modifiedData.porting_num_type = data[field]["porting_num_type"];
      //       }
      //       if (field === "notifs_comments") {
      //         modifiedData.send_email_to_admin =
      //           data[field]["send_email_to_admin"];
      //       }
      //     } else {
      //       modifiedData[field] = data[field];
      //     }
      //   }
      // }

      const formData = new FormData();

      formData.append(
        "siteid",
        JSON.parse(sessionStorage.getItem("admin_session")).siteid
      );
      formData.append(
        "reqid",
        parseInt(portingType) === 1 ? 91 : parseInt(portingType) === 2 ? 95 : 96
      );
      formData.append("port_type", parseInt(portingType));
      formData.append("flow_step", parseInt(flowStep));
      // formData.append("flow_step", parseInt(currentStep));
      if (orderID) {
        formData.append("orderid", orderID);
      }
      formData.append("save_as_draft", true);
      for (const field of Object.keys(dirtyFields)) {
        let modifiedData = {};
        if (dirtyFields[field] && data.hasOwnProperty(field)) {
          if (typeof data[field] === "object" && !Array.isArray(data[field])) {
            for (const subfield of Object.keys(dirtyFields[field])) {
              if (data[field].hasOwnProperty(subfield)) {
                modifiedData[subfield] = data[field][subfield];
              }
            }
            if (field === "acc_info" && portingType === 2) {
              modifiedData.porting_num_type = data[field]["porting_num_type"];
            }
            if (field === "notifs_comments") {
              modifiedData.send_email_to_admin =
                data[field]["send_email_to_admin"];
            }

            if (field !== "checklist") {
              formData.append(field, JSON.stringify(modifiedData));
            }
          } else {
            modifiedData = [...data[field]];
            formData.append(field, JSON.stringify(modifiedData));
          }
        }
      }
      formData.append("checklist", JSON.stringify(data.checklist));
      // if (modifiedData) {
      //   modifiedData.reqid =
      //     parseInt(portingType) === 1
      //       ? 91
      //       : parseInt(portingType) === 2
      //         ? 95
      //         : 96;
      //   modifiedData.siteid = JSON.parse(
      //     sessionStorage.getItem("admin_session")
      //   ).siteid;
      //   modifiedData.port_type = parseInt(portingType);
      //   modifiedData.flow_step = parseInt(currentStep);
      //   modifiedData.save_as_draft = 1;
      //   console.log(
      //     "final final update Field is ::::::::::: " +
      //       JSON.stringify(modifiedData)
      //   );
      let saverep = await portingStepsForm(formData);
      console.log(`reponse of next :::: ${JSON.stringify(saverep)}`);
      let saverepeMsg = await saverep.json();
      console.log("response of next:::" + JSON.stringify(saverepeMsg));

      if (saverepeMsg.status && saverepeMsg.status == "success") {
        setsavedDraftData(data);
        setSuccessMessage(saverepeMsg.message);
        if (saverepeMsg?.orderid) {
          setorderID(saverepeMsg?.orderid);
        }
      } else {
        if (saverepeMsg.message?.errors) {
          saverepeMsg.message.errors.forEach((err) => {
            setError(err.param_name, {
              type: "server",
              message: err.message,
            });
            const fieldElement = document.querySelector(
              `input[name="${err.param_name}"]`
            );
            if (fieldElement) {
              fieldElement.focus();
              fieldElement.scrollIntoView({ behavior: "smooth" });
            }
          });
        } else {
          //   setInternalError(true);
        }
      }
      // }
    }
  };

  return (
    <>
      <div className="pb-3 container enter-account-info-container" onKeyDown={handleTabKeyNavigation}>
        <h5>Checklist</h5>
        {errors.checklist && (
          <div className="bg-danger bg-opacity-25 px-3 py-2 rounded-3 mb-3 d-flex align-items-center border border-2 border-danger shadow-2-strong ">
            <MDBIcon icon="exclamation-triangle" className="me-3" color="danger" size="lg" />
            <p className="text-danger">{errors.checklist.message}</p>
          </div>
        )}
        <div className="PNChecklist">
          <p className="text-danger">
            Are the numbers you are transferring active with your current
            Service Provider?
          </p>
          <MDBRadio
            name="checklist.check_ans_one"
            id="inlineRadio1"
            value={true}
            label="Yes"
            inline
            checked={watch("checklist.check_ans_one") === true}
            onClick={() => {
              setValue("checklist.check_ans_one", true, { shouldDirty: true });
              clearErrors("checklist");
            }}
          />
          <MDBRadio
            name="checklist.check_ans_one"
            id="inlineRadio2"
            value={false}
            label="No"
            inline
            checked={watch("checklist.check_ans_one") === false}
            onClick={() => {
              setValue("checklist.check_ans_one", false, { shouldDirty: true });
              clearErrors("checklist");
            }}
          />
          <p className="text-danger">
            It is not possible to transfer inactive numbers
          </p>
        </div>
        <div className="mt-3">
          <p>
            Do you currently have any additional telephone services associated
            with your number, such as hunt groups, voicemail, etc.
          </p>
          <MDBRadio
            name="checklist.check_ans_two"
            id="inlineRadio3"
            value={true}
            label="Yes"
            inline
            checked={watch("checklist.check_ans_two") === true}
            onClick={() => {
              clearErrors("checklist");
              setValue("checklist.check_ans_two", true, { shouldDirty: true });
            }}
          />
          <MDBRadio
            name="checklist.check_ans_two"
            id="inlineRadio4"
            value={false}
            label="No"
            inline
            checked={watch("checklist.check_ans_two") === false}
            onClick={() => {
              clearErrors("checklist");
              setValue("checklist.check_ans_two", false, {
                shouldDirty: true,
              });
            }}
          />
          <div className="bg-success p-2 bg-opacity-10 rounded-4">
            <p className="small">
              If you have additional Telephone services, such as hunt groups,
              voicemail enabled. It may cause delay in your porting request or
              may be rejected. You may want to contact your current provider
              prior to submitting your transfer request.
            </p>
            <b className="small">
              It is important to note that pending and open orders may cause a
              delay in your porting request or may be rejected
            </b>
          </div>
        </div>
        <div className="mt-3">
          <p>
            Do you currently have DSL/Broadband on any of the numbers you are
            transferring?
          </p>
          <MDBRadio
            name="checklist.check_ans_three"
            id="inlineRadio5"
            value={true}
            label="Yes"
            inline
            checked={watch("checklist.check_ans_three") === true}
            onClick={() => {
              clearErrors("checklist");
              setValue("checklist.check_ans_three", true, {
                shouldDirty: true,
              });
            }}
          />
          <MDBRadio
            name="checklist.check_ans_three"
            id="inlineRadio6"
            value={false}
            label="No"
            inline
            checked={watch("checklist.check_ans_three") === false}
            onClick={() => {
              clearErrors("checklist");
              setValue("checklist.check_ans_three", false, {
                shouldDirty: true,
              });
            }}
          />
          <div className="bg-success p-2 bg-opacity-10 rounded-4">
            <p className="small">
              If you have DSL/Broadband services associated with any of the
              numbers you are transferring, it may cause a delay in your porting
              request or may be rejected. You may want to contact your current
              provider prior to submitting your transfer request.
            </p>
            <b className="small">
              It is important to note that pending and open orders may cause a
              delay in your porting request or may be rejected
            </b>
          </div>
        </div>
        <div className="mt-3">
          <p>
            Do you currently have any open orders with your current Service
            Provider?
          </p>
          <MDBRadio
            name="checklist.check_ans_four"
            id="inlineRadio7"
            value={true}
            label="Yes"
            inline
            checked={watch("checklist.check_ans_four") === true}
            onClick={() => {
              clearErrors("checklist");
              setValue("checklist.check_ans_four", true, { shouldDirty: true });
            }}
          />
          <MDBRadio
            name="checklist.check_ans_four"
            id="inlineRadio8"
            value={false}
            label="No"
            inline
            checked={watch("checklist.check_ans_four") === false}
            onClick={() => {
              clearErrors("checklist");
              setValue("checklist.check_ans_four", false, {
                shouldDirty: true,
              });
            }}
          />
          <div className="bg-success p-2 bg-opacity-10 rounded-4">
            <p className="small">
              Please cancel all open orders with your current provider or your
              transfer request will fail.
            </p>
          </div>
        </div>

        <div className="PNChecklist mt-3">
          <p className="text-danger">
            Do you have your IP-Phones OR Softphones ready for use?
          </p>
          <MDBRadio
            name="checklist.check_ans_five"
            id="inlineRadio9"
            value={true}
            label="Yes"
            inline
            checked={watch("checklist.check_ans_five") === true}
            onClick={() => {
              clearErrors("checklist");
              setValue("checklist.check_ans_five", true, { shouldDirty: true });
            }}
          />
          <MDBRadio
            name="checklist.check_ans_five"
            id="inlineRadio10"
            value={false}
            label="No"
            inline
            checked={watch("checklist.check_ans_five") === false}
            onClick={() => {
              clearErrors("checklist");
              setValue("checklist.check_ans_five", false, {
                shouldDirty: true,
              });
            }}
          />
        </div>
      </div>
      <MDBModalFooter className="d-flex justify-content-between">
        <MDBBtn
          color="secondary"
          onClick={(e) => {
            e.preventDefault();
            handleSubmit(handleSaveDraft)();
          }}
          className="text-normal-case"
        >
          Save to Draft
        </MDBBtn>
        <span id="draftsuccess"></span>
        <div className="text-end">
          <MDBBtn
            color="secondary"
            className="me-2"
            onClick={handleForBack}
            disabled={currentStep === 0}
          >
            Back
          </MDBBtn>
          <MDBBtn
            onClick={(e) => {
              e.preventDefault();
              handleSubmit(handleNext)();
            }}
          >
            Next
          </MDBBtn>
          {/* <MDBBtn onClick={nextPageclick}>Next</MDBBtn> */}
        </div>
      </MDBModalFooter>
    </>
  );
}
